import { Image, Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDeratizacijaEvdListaEvidencijaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  slikaDeklaracije: string;
  tackaEvidencije: string;
}> = ({ datum, fullname, potpis, slikaDeklaracije, tackaEvidencije }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{slikaDeklaracije}</Text>
    </View>
  </View>
);

export const TableRowDeratizacijaEvdListaEvidencija: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  slikaDeklaracije?: string;
  tackaEvidencije: string;
  slikaRes: string;
}> = ({
  datum,
  fullname,
  potpis,
  slikaDeklaracije,
  tackaEvidencije,
  slikaRes,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      {slikaDeklaracije && (
        <Link
          src={slikaDeklaracije}
          style={{ ...styles.tableCell, ...styles.link }}
        >
          {slikaRes}
        </Link>
      )}
    </View>
  </View>
);
